import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import {
    Logo,
    Wrapper,
    InnerWrapper,
    ContentWrapper,
    WelcomeWrapper,
    TextWrapper,
    FormWrapper,
    InputWrapper,
    ButtonWrapper
} from "./styled";
import { Space } from "components";
import { AppContext } from "hocs/withAppContext";

const EMAIL_FIELD = 'email';
const DEFAULT_VIEW = (roleId) => `/${roleId}/work-orders`;

const LoginView = ({ history, match }) => {
    const { role } = useContext(AppContext);
    const logo = role && role.companyLogo
        ? role.companyLogo.url
        : 'https://app.onupkeep.com/images/logo-red.svg';

    const defaultEmail = localStorage.getItem(EMAIL_FIELD);
    const [email, setEmail] = useState(defaultEmail);

    const handleOnChange = e => setEmail(e.target.value);
    const handleSubmit = (e) => {
        e.preventDefault();
        localStorage.setItem(EMAIL_FIELD, email);
        history.push(DEFAULT_VIEW(match.params.id));
    };

    if (defaultEmail) {
        return <Redirect to={DEFAULT_VIEW(match.params.id)}/>
    }

    return (
        <Wrapper>
            <InnerWrapper>
                <Logo src={logo}/>

                <ContentWrapper>
                    <WelcomeWrapper> Welcome to our Portal! </WelcomeWrapper>
                    <TextWrapper>
                        Log in with your email to add and view your submitted requests
                    </TextWrapper>
                    <Space/>
                    <FormWrapper onSubmit={handleSubmit}>
                        <InputWrapper
                            placeholder="Enter your email address"
                            type="email"
                            value={email}
                            onChange={handleOnChange}
                            required
                        />
                        <Space/>
                        <ButtonWrapper>Log In</ButtonWrapper>
                    </FormWrapper>
                </ContentWrapper>
            </InnerWrapper>
        </Wrapper>
    );
};

export default LoginView;
